// Renders SVFViewer fullscreen on mobile when a 3D file is selected
import { SVFViewer } from '~components/atoms/Viewers/SVFViewer/SVFViewer';
import { useFileViewerContext } from '~src/contexts/FileToViewContext';

export const MobileViewerHost: React.FC = () => {
  const { fileToView, setFileToView } = useFileViewerContext();

  if (!fileToView) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: '#000',
        zIndex: 10,
        display: 'flex',
        flexDirection: 'column',
      }}>
      <SVFViewer
        fileToView={fileToView}
        onClose={() => setFileToView(undefined)}
        showTitle={true}
      />
    </div>
  );
};
